export const RESET_STATE = "RESET_STATE";
export const RESET_VALUE = "RESET_VALUE";
export const NEW_VALUE = "NEW_VALUE";
export const ADD_DIGIT = "ADD_DIGIT";
export const REMOVE_LAST_DIGIT = "REMOVE_DIGIT";
export const RESET_DIGITS = "RESET_DIGITS";
export const HANDLE_OPERATOR = "HANDLE_OPERATOR";
export const HANDLE_EQUAL = "HANDLE_EQUAL";
export const REMOVE_HISTORY = "REMOVE_HISTORY";
export const CHANGE_HISTORY_NAME = "CHANGE_HISTORY_NAME";
